import { render } from "./HomeSlider.vue?vue&type=template&id=d5978bc8&scoped=true"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=d5978bc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5978bc8"]])

export default __exports__
import QScrollObserver from 'quasar/src/components/scroll-observer/QScrollObserver.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollObserver,QCarousel,QCarouselSlide});
